import { LicenseModelTransactionVendor } from './consts';
import { Music24Capabilities, music24PlanCapabilities } from './music24Plans';
import type { Music24LicenseStateType } from './music24Types';

/**
 * A licence with no valid Music24 item is on Free. This row is for a caller without a licence, so
 * AI Reels and Outreach stay off: a reel and a campaign belong to a workspace, and this caller has none.
 */
export const music24NoCapabilities: Music24Capabilities = {
  ...music24PlanCapabilities.free,
  canUseAiReels: false,
  canUseOutreach: false,
};

export const music24NoLicense: Music24LicenseStateType = {
  isValid: false,
  email: null,
  subscriptionExpiresAt: null,
  transactionVendor: LicenseModelTransactionVendor.Unknown,
  features: {
    hasSMLRetargeting: false,
    hasSMLMusicPlayer: false,
    hasSMLCustomization: false,
    hasSMLWhiteLabel: false,
  },
  limits: {
    smlAccountsLimit: music24PlanCapabilities.free.artistsLimit,
    smlSmartLinksLimit: music24PlanCapabilities.free.publishedPagesLimit,
    smlUsersLimit: music24PlanCapabilities.free.seatsLimit,
  },
  smlCapabilities: music24NoCapabilities,
  trial: {
    status: 'none',
    endsAt: null,
  },
};
